/**
 * Instagram Feed Configuration
 * 
 * Customize these settings to control how Instagram posts are displayed
 */

export const instagramConfig = {
  // Instagram username to display
  username: 'lulaendocomunidad',
  
  // Number of posts to fetch and display
  postsLimit: 6,
  
  // Fallback behavior when API is not configured
  fallbackMessage: 'Instagram API no está configurado. Configura las credenciales para ver las publicaciones.',
  
  // Section title
  sectionTitle: 'Últimos posts en Instagram',
  
  // Section description
  sectionDescription: 'Mantente al día con nuestras últimas publicaciones en',
  
  // Call-to-action button text
  ctaButtonText: 'Ver más en Instagram',
  
  // Loading message
  loadingMessage: 'Cargando publicaciones...',
  
  // Error message
  errorMessage: 'No se pudieron cargar las publicaciones de Instagram.',
};

export default instagramConfig;

